import InputDate from '../../components/input_date/_input_date.js';
import Popup from '../../components/popup/_popup.js';

var f = {}, // f: patient fields container
    dateFormatVal = $('#patient_dateFormat input[type="radio"][checked]').val(),
    /* values, not labels > no need to translate */
    noDoc = 'None',
    referPatient = window.Translation?.['patientRefer'],
    emailSent = window.Translation?.['emailSent'];

var PatientForm = {

    init: function () {
        dateFormatVal = $('#patient_dateFormat input[type="radio"][checked]').val()
        f = {};

        $(".WarningContainer").remove();

        $('*[id^=patient').each(function () {
            const regex = /patient\_([a-zA-Z].*)/g;
            let fieldName = regex.exec($(this).attr('id'));
            if (fieldName != null)
                f[fieldName[1]] = $(this);
        })

        /* What type of ID exists */
        f.idType.change(function () {
            PatientForm.idTypeCheck();
            PatientForm.checkNotificationWarning();
        });
        f.benefType.change(function () {
            PatientForm.checkNotificationWarning();
        });

        // /* Patient consent */
        f.consent.change(function () {
            PatientForm.consentCheck();
        });

        /* Reset the fields */
        $('.Button[data-modal="#modal_patient"]').on('click', function () {
            PatientForm.init($('#modal_PatientForm.ModalWrapper'));
        })

        function toggleActive(element) {
            element.siblings('.Tag--gray').toggleClass('hidden');
            element.siblings('.Tag--blue').toggleClass('hidden');
        }
        $('span[data-field-update="idType"]').on('change', function () {
            toggleActive($(this));
        });
        $('span[data-field-update="consent"]').on('change', function () {
            toggleActive($(this));
        })

        InputDate.init();
        InputDate.change(dateFormatVal);
        PatientForm.consentCheck();
    },

    showDuplicatedPopup: function (data) {
        const { id, fullName, patientUrl } = data
        const duplicationPopup = $('#patient_duplicate_popup')
        duplicationPopup.find('[data-id]').html(id)
        duplicationPopup.find('[data-fullname]').html(fullName)
        duplicationPopup.find('[data-patient-link]').attr('href', patientUrl)
        Popup.show('#patient_duplicate_popup');
    },

    idTypeCheck: function () {
        $(".WarningContainer").remove();
        const status = f.idType.val();
        if (status === noDoc) {
            f.uniqueId.val('').attr('readonly', true).attr('required', false);
        } else {
            f.uniqueId.removeAttr('readonly').attr('required', true)
        }
    },

    checkNotificationWarning: function () {
        $(".WarningContainer").remove();
        const idType = f.idType.val();
        if (idType == noDoc) {
            const benefType = f.benefType.val();
            const isNotificationRequired = $('option:selected', f.benefType).attr("is-notificationemail-required") === "true";
            if (benefType) {
                PatientForm.addNotifMesg(isNotificationRequired);
            }
        }
    },

    consentCheck: function () {
        let consent = $("input[name='patient[consent]']:checked").val();

        if (consent === "1") {
            InputDate.disableYearMode();
            f.idType.removeAttr('readonly').attr('required', true);
            f.firstName.removeAttr('readonly').attr('required', true);
            f.middleName.removeAttr('readonly');
            f.lastName.removeAttr('readonly').attr('required', true);
            PatientForm.idTypeCheck();

            if (f.currentAddress) f.currentAddress.removeAttr('readonly');
            if (f.contactNumber) f.contactNumber.removeAttr('readonly');
            if (f.alternativeContactName) f.alternativeContactName.removeAttr('readonly');
            if (f.alternativeContactNumber) f.alternativeContactNumber.removeAttr('readonly');
        } else {
            $(".WarningContainer").remove();
            InputDate.enableYearMode();
            f.idType.val('').attr('readonly', true).removeAttr('required');
            f.idType.find('option:selected').text('');
            f.uniqueId.val('').attr('readonly', true);
            f.firstName.val('').attr('readonly', true).removeAttr('required');
            f.middleName.val('').attr('readonly', true);
            f.lastName.val('').attr('readonly', true).removeAttr('required');

            if (f.currentAddress) f.currentAddress.val('').attr('readonly', true)
            if (f.contactNumber) f.contactNumber.val('').attr('readonly', true)
            if (f.alternativeContactName) f.alternativeContactName.val('').attr('readonly', true)
            if (f.alternativeContactNumber) f.alternativeContactNumber.val('').attr('readonly', true)
        }
    },

    addNotifMesg: function (withEmail = true) {
        let notifText = "<li class='Warning'>" + referPatient + "</li>";
        if (withEmail) {
            notifText += "<li class='Warning'>" + emailSent + "</li>";
        }
        let notifMesg = $('<ul class="WarningContainer">' + notifText + '</ul>');
        f.idType.after(notifMesg);
    }
}

export default PatientForm;